var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "view_cont" }, [
              _c("div", { staticClass: "view_info" }, [
                _c(
                  "div",
                  { staticClass: "view_category" },
                  [
                    _vm._v(
                      " \n                                " +
                        _vm._s(_vm.knowledgeDetail.PRD_CATEGORY_NM1) +
                        "\n                                "
                    ),
                    typeof _vm.knowledgeDetail.PRD_CATEGORY_NM2 !== "undefined"
                      ? [
                          _vm._v(
                            "> " + _vm._s(_vm.knowledgeDetail.PRD_CATEGORY_NM2)
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    typeof _vm.knowledgeDetail.PRD_CATEGORY_NM3 !== "undefined"
                      ? [
                          _vm._v(
                            "> " + _vm._s(_vm.knowledgeDetail.PRD_CATEGORY_NM3)
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "view_subject" }, [
                _c("dt", { staticClass: "subject" }, [
                  _vm.knowledgeDetail.IMPORTANCE_YN === "Y"
                    ? _c("em", { staticClass: "textcolor_important" }, [
                        _vm._v(
                          "[" + _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) + "]"
                        )
                      ])
                    : _vm.knowledgeDetail.MUST_READ_YN === "Y"
                    ? _c("em", { staticClass: "textcolor_must" }, [
                        _vm._v(
                          "[" + _vm._s(_vm.$t("FIELD.GLOBAL.MUSTREAD")) + "]"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.knowledgeDetail.KNOWLEDGE_TITLE) +
                      "\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "desc hhp_desc" }, [
                  _c("span", { staticClass: "desc_Regist" }, [
                    _c("em", [_vm._v("Registered by")]),
                    _vm._v(
                      _vm._s(_vm.knowledgeDetail.REG_USER_NM) +
                        "(" +
                        _vm._s(_vm.knowledgeDetail.CORP_NM) +
                        ") (" +
                        _vm._s(_vm.knowledgeDetail.REG_DT) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "desc_modify" }, [
                    _c("em", [_vm._v("Last Modified by")]),
                    _vm._v(
                      _vm._s(_vm.knowledgeDetail.MODF_USER_NM) +
                        " (" +
                        _vm._s(_vm.knowledgeDetail.MODF_DT) +
                        ")"
                    )
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "desc_Target" }, [
                    _c("em", [_vm._v("Target")]),
                    _vm._v(_vm._s(_vm.knowledgeDetail.DIST_TARGET))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "desc_AllowSharing" }, [
                    _c("em", [_vm._v("Allow Sharing ")]),
                    _vm._v(_vm._s(_vm.knowledgeDetail.ALLOW_SHARE) + "  ")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "view_desc" }, [
                _c(
                  "div",
                  { staticClass: "grid_wrap" },
                  [
                    _c("div", { staticClass: "btn_wrap" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: { href: "javascript:", title: "" },
                          on: {
                            click: function($event) {
                              return _vm.excelDownload()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.EXCELDOWNLOAD")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("toast-grid", {
                      key: _vm.gridKey,
                      attrs: {
                        gridId: _vm.gridId,
                        data: _vm.gridData,
                        columns: _vm.columns,
                        options: _vm.options,
                        pageOptions: _vm.pageOptions,
                        isTotalCount: true
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis maintit" }, [
      _c("i", [_vm._v("See Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ccdedcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ccdedcd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/statisticsManager/UnreadPop.vue
// module id = Vrzn
// module chunks = 0